import PrismicLink from "./PrismicLink";
export default PrismicLink;
